module.exports = __webpack_public_path__ + "static/media/Samurott_gaussian2.b24c9e4e.png";